export default "__VITE_ASSET__BLI$xvuh__"